import { PromoCodeDiscountType } from './promo-code-discount-type';
//import moment from 'moment-es6';
import { MomentService } from '../../../shared/moment/moment.service';

export class EventPromoCode {
  private _momentService: MomentService;

  public constructor() {
    this._momentService = new MomentService();

    this.PromoCodeId = 0;
    this.Name = '';
    this.Code = '';
    this.DiscountType = 0;
    this.Discount = PromoCodeDiscountType.Dollar;
    this.MaxUses = 0;
    this.StartDate = this._momentService
      .getMoment()
      .startOf('day')
      .toDate();
    this.StartTime = '';
    this.EndDate = this._momentService
      .getMoment()
      .startOf('day')
      .toDate();
    this.EndTime = '';
    this.EventId = 0;
    this.EventItemIds = [];
    this.AdjustmentTypeId = 0;
    this.Used = 0;
    this.TotalDiscounts = 0;
  }
  public PromoCodeId: number;
  public Name: string;
  public Code: string;
  public DiscountType: PromoCodeDiscountType = PromoCodeDiscountType.Dollar;
  public Discount: number;
  public MaxUses: number;
  public StartDate: Date;
  public StartTime: string;
  public Expires: boolean = true;
  public EndDate: Date;
  public EndTime: string;
  public EventId: number;
  public EventItemIds: number[];
  public AdjustmentTypeId: number;
  public Used: number;
  public TotalDiscounts: number;
  public ApplyOncePerReg: boolean = false;
}
